// extracted by mini-css-extract-plugin
export default {"root":"joeIK__root","thumbnail":"w6XTU__thumbnail"};